import * as yup from "yup";
const noOp = () => {};

export const initializeBraintree = async (
  token,
  containerId,
  { onStart = noOp, onSuccess = noOp, onFailure = noOp, onDone = noOp },
) => {
  try {
    onStart();
    const instance = await window.braintree.dropin.create({
      authorization: token,
      selector: containerId,
      dataCollector: true,
      vaultManager: false,
      card: {
        cardholderName: true,
        vault: {
          allowVaultCardOverride: false,
          vaultCard: false,
        },
      },
    });

    onSuccess(instance);
  } catch (error) {
    onFailure(error);
    console.error("Error initializing Braintree:", error);
  } finally {
    onDone();
  }
};

export const getPaymentType = (paymentCode) => {
  switch (paymentCode) {
    case "CRDCARD":
      return "Credit Card";

    case "CreditCard":
      return "CRDCARD";

    case "DBTCARD":
      return "Debit Card";

    case "DebitCard":
      return "DBTCARD";

    case "MANUALCHECK":
      return "Manual Check";

    case "MANUALACH":
      return "Manual ACH";

    case "MISCINV":
      return "Miscellaneous Invoice";

    case "DEPINV":
      return "Deposit Invoice";

    default:
      return capitalizeFirstLetter(paymentCode);
  }
};

function capitalizeFirstLetter(string = "") {
  if (string)
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}

export const ACH_PAYMENT_COUNTRIES = {
  USA: "USA",
  CANADA: "CAN",
  MEXICO: "MX",
};

export const ACH_PAYMENT_SCHEMNA = yup.object().shape({
  name: yup.string().required("Name is a required field"),
  routingNumber: yup.string().required("Routing Number is a required field"),
  accountNumber: yup.string().required("Account Number is a required field"),
  accountCountry: yup.string().required("Account Countryis a required field"),
  accountName: yup.string().required("Account Name  is a required field"),
  address: yup.string().required("Address is a required field"),
  city: yup.string().required("City is a required field"),
  state: yup.string().required("State is a required field"),
  country: yup.string().required("Country is a required field"),
  zipCode: yup
    .string()
    .required("Zipcode is a required field")
    .matches(/^\d{5}(?:[-\s]\d{4})?$/, "Invalid zipcode format"),
});

export const PAYMENT_TYPE = {
  DBT_CRED: "DBT_CRED",
  ACH: "ACH",
};
